import React from 'react';
import { useNavigation } from '@react-navigation/native';
import { useLayoutSize } from '../../theme';
import BackOfficeSidebarLayout from './BackOfficeSidebarLayout';
import WebHeaderBarInjector from './WebHeaderBarInjector';
import type { WebHeaderBarProps } from './WebHeaderBar';

type Props = {
  children: React.ReactNode;
  /** Props forwarded to WebHeaderBar. Omit onBack to get default navigation.goBack(). */
  header?: Omit<WebHeaderBarProps, 'onBack'> & { onBack?: () => void };
};

/**
 * Convenience wrapper: BackOfficeSidebarLayout + automatic WebHeaderBar injection.
 */
export default function BackOfficeScreenShell({ children, header }: Props) {
  return (
    <BackOfficeSidebarLayout>
      {header ? <WebHeaderBarInjectorWithNav {...header} /> : null}
      {children}
    </BackOfficeSidebarLayout>
  );
}

function WebHeaderBarInjectorWithNav(
  props: Omit<WebHeaderBarProps, 'onBack'> & { onBack?: () => void },
) {
  const { useSidebarNav } = useLayoutSize();
  const navigation = useNavigation();
  if (!useSidebarNav) return null;

  const onBack =
    props.onBack ??
    (() => {
      try {
        if (navigation.canGoBack()) navigation.goBack();
      } catch {}
    });

  return <WebHeaderBarInjector {...props} onBack={onBack} />;
}
